import { NavMenuComponent } from './navmenu/navmenu.component';
import { HomeComponent } from './home/home.component';
import { AdminComponent } from './admin/admin.component';
import { HeaderComponent } from './header/header.component';
import { TopMenuComponent } from './top-menu/top-menu.component';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { DataViewHeaderComponent } from './data-view-header/data-view-header.component';
import { DataViewGridComponent } from './data-view-grid/data-view-grid.component';
import { ContextMenuComponent } from './context-menu/context-menu.component';
import { SingleViewComponent } from './single-view/single-view.component';
import { FileSelectionComponent } from './file-selection/file-selection.component';
import { LoginComponent } from './login/login.component';
import { MainViewComponent } from './main-view/main-view.component';
import { ErrorViewComponent } from './error-view/error-view.component';
import { ProfileViewComponent } from './profile-view/profile-view.component';
import { SingleViewCustomComponent } from './single-view-custom/single-view-custom.component';
import { SingleViewCustomActionComponent } from './single-view-custom-action/single-view-custom-action.component';
import { CertViewComponent } from './cert-view/cert-view.component';
import { AboutViewComponent } from './custom/about-view/about-view.component';

export {
  NavMenuComponent,
  HomeComponent,
  AdminComponent,
  HeaderComponent,
  TopMenuComponent,
  SideMenuComponent,
  DataViewHeaderComponent,
  DataViewGridComponent,
  ContextMenuComponent,
  SingleViewComponent,
  FileSelectionComponent,
  LoginComponent,
  MainViewComponent,
  ErrorViewComponent,
  ProfileViewComponent,
  SingleViewCustomComponent,
  SingleViewCustomActionComponent,
  CertViewComponent,
  AboutViewComponent
};



// WEBPACK FOOTER //
// ./src/app/components/index.ts